import {FormattedMessage} from 'react-intl';
import QuickTip from 'shared/components/QuickTip';
import {auth} from 'main/tools';

const DemoAccountWarning = () => {
  if (!auth.company.demoAccount) return null;

  return (
    <div className='mb2'>
      <QuickTip
        trait='caution'
        header={<FormattedMessage id='components.demo_account_warning.Creating Demo Data'/>}
      >
        <FormattedMessage id='components.demo_account_warning.Anything you create now will be deleted when you clear demo data.'/>
      </QuickTip>
    </div>
  );
};

export default DemoAccountWarning;
